import React, { useMemo } from 'react'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

const RecipientsNotified = ({
	notifiedEntities = [],
	notifiedEstablishments = [],
}) => {
	const { i18n } = useGlobal()

	const notifiedOptions = useMemo(() => {
		if (
			notifiedEntities.length === 0 &&
			notifiedEstablishments.length === 0
		) {
			return [
				{
					value: 'no-establishments-notified',
					text: i18n`Without recipients`,
				},
			]
		}

		const notifiedEntitiesOptions = notifiedEntities.map((entity) => ({
			value: entity.id,
			text: i18n.translate(entity.name),
		}))

		const notifiedEstablishmentsOptions = notifiedEstablishments.map(
			(establishment) => ({
				value: `establishment-${establishment.id}`,
				text: establishment.name,
			})
		)

		return [...notifiedEntitiesOptions, ...notifiedEstablishmentsOptions]
	}, [i18n, notifiedEntities, notifiedEstablishments])

	return (
		<VStack>
			<small>
				<strong>
					{i18n.translate(
						`Recipient${notifiedOptions.length > 1 ? 's' : ''}`
					)}
				</strong>
			</small>
			{notifiedOptions.map((item) => (
				<small key={item.value}>{item.text}</small>
			))}
		</VStack>
	)
}

export default RecipientsNotified
